import React, { useState, useEffect } from 'react';
import './Hero.css';

function Hero({ onJoinWaitlist }) {
  const [currentLanguageIndex, setCurrentLanguageIndex] = useState(0);
  const [currentDemoIndex, setCurrentDemoIndex] = useState(0);

  const languages = [
    'हिंदी',      // Hindi
    'বাংলা',      // Bengali
    'ગુજરાતી',    // Gujarati
    'ಕನ್ನಡ',      // Kannada
    'മലയാളം',     // Malayalam
    'मराठी',      // Marathi
    'ଓଡ଼ିଆ',       // Odia
    'ਪੰਜਾਬੀ',     // Punjabi
    'தமிழ்',      // Tamil
    'తెలుగు',     // Telugu
    'English'     // English
  ];

  const demonstrations = [
    {
      language: 'Hindi',
      text: 'राजेश ने 2 समोसा और 1 चाय लिया ₹100 UPI किया',
      entry: '🧾 Customer: राजेश | Items: 2 समोसा, 1 चाय | ₹100 | UPI'
    },
    {
      language: 'Telugu',
      text: 'రమేష్ కి 3 ఇడ్లీ మరియు 1 కాఫీ ఇచ్చాను ₹80 నగదు తీసుకున్నాను',
      entry: '🧾 Customer: రమేష్ | Items: 3 ఇడ్లీ, 1 కాఫీ | ₹80 | Cash'
    },
    {
      language: 'Odia',
      text: 'ସୁରେଶ 5 ପକୋଡ଼ା ନେଲେ ₹150 UPI କଲେ',
      entry: '🧾 Customer: ସୁରେଶ | Items: 5 ପକୋଡ଼ା | ₹150 | UPI'
    }
  ];

  // Rotate languages in heading every 2 seconds
  useEffect(() => {
    const languageInterval = setInterval(() => {
      setCurrentLanguageIndex((prev) => (prev + 1) % languages.length);
    }, 2000);
    return () => clearInterval(languageInterval);
  }, [languages.length]);

  // Rotate demo examples every 4 seconds
  useEffect(() => {
    const demoInterval = setInterval(() => {
      setCurrentDemoIndex((prev) => (prev + 1) % demonstrations.length);
    }, 4000);
    return () => clearInterval(demoInterval);
  }, [demonstrations.length]);

  const handleWatchExplainer = () => {
    window.open('https://youtu.be/zGXnYkcO1Tk?si=7BNkjHJ0PlfYdlk-', '_blank');
  };

  const handleWatchDemo = () => {
    window.open('https://www.youtube.com/watch?v=nWuITAOiJg8', '_blank');
  };

  return (
    <section className="hero">
      <h1>
        The First Bookkeeping App That Understands{' '}
        <span className="rotating-language" key={currentLanguageIndex}>
          {languages[currentLanguageIndex]}
        </span>
        <br />and Your Busy Schedule
      </h1>
      <p className="subtitle">Stop Typing. Start Speaking. Your Bookkeeping Done in Seconds</p>

      {/* YouTube Video Icon */}
      <div className="youtube-icon-container" onClick={handleWatchExplainer}>
        <div className="youtube-icon">
          <svg viewBox="0 0 24 24" className="youtube-svg">
            <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
          </svg>
          <div className="play-button">
            <svg viewBox="0 0 24 24" className="play-svg">
              <path d="M8 5v14l11-7z" />
            </svg>
          </div>
        </div>
        <p className="youtube-text">Watch Explainer Video</p>
      </div>

      {/* Animated Demo */}
      <div className="demo-animation">
        <div className="demo-card">
          <div className="demo-header">
            <div className="mic-icon">🎤</div>
            <span className="language-badge">{demonstrations[currentDemoIndex].language}</span>
          </div>

          {/* Voice Wave Animation */}
          <div className="voice-wave">
            <div className="wave-bar"></div>
            <div className="wave-bar"></div>
            <div className="wave-bar"></div>
            <div className="wave-bar"></div>
            <div className="wave-bar"></div>
            <div className="wave-bar"></div>
            <div className="wave-bar"></div>
            <div className="wave-bar"></div>
          </div>

          <div className="demo-text">
            <p className="speaking-text" key={currentDemoIndex}>
              "{demonstrations[currentDemoIndex].text}"
            </p>
          </div>

          <div className="arrow-down">↓</div>

          <div className="demo-result" key={`result-${currentDemoIndex}`}>
            <div className="result-badge">✨ Auto-Generated Entry</div>
            <p className="entry-text">{demonstrations[currentDemoIndex].entry}</p>
          </div>
        </div>
      </div>

      <div className="hero-buttons">
        <button className="primary-btn" onClick={onJoinWaitlist}>Join Waitlist</button>
        <button className="secondary-btn" onClick={handleWatchDemo}>Watch Demo</button>
      </div>
    </section>
  );
}

export default Hero;
